import { render } from "./PayOrder.vue?vue&type=template&id=3418cbca"
import script from "./PayOrder.vue?vue&type=script&lang=js"
export * from "./PayOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__